/* ============================================================================
 * oak-finishes.js — the six White Oak Inset stain finishes.
 *
 * Names, codes and swatch photos are the store's own: they are the variants of
 * the "Color Selection" and "Color Sample" products, so what the shopper picks
 * here is exactly what the office reads on the order.
 *
 * There is deliberately NO hex here. A stain is not a flat colour, and guessing
 * one would put an invented tone on a customer's cabinet. The tone is measured
 * from the swatch photo itself at display time (see oak-box-visualizer.js), so
 * the preview follows the real sample: replace a swatch photo and the preview
 * follows it with no code change. If a swatch cannot be loaded, nothing is
 * recoloured — the photographed cabinet stands, same rule as the painted side.
 * ==========================================================================*/
window.OAK_FINISHES = [
  { code: 'WS-01', name: 'Saddle Oak',    swatch: 'https://cdn.shopify.com/s/files/1/0169/0386/4420/files/WS01.webp' },
  { code: 'WS-02', name: 'Walnut Oak',    swatch: 'https://cdn.shopify.com/s/files/1/0169/0386/4420/files/WS02.webp' },
  { code: 'WS-03', name: 'Coffee Oak',    swatch: 'https://cdn.shopify.com/s/files/1/0169/0386/4420/files/WS03_69531d1f-edf9-4b4a-ba69-63462f711967.webp' },
  { code: 'WS-04', name: 'Chocolate Oak', swatch: 'https://cdn.shopify.com/s/files/1/0169/0386/4420/files/WS04_9aa7467a-6329-4574-82a3-249206b44713.webp' },
  { code: 'WS-05', name: 'Sand Oak',      swatch: 'https://cdn.shopify.com/s/files/1/0169/0386/4420/files/WS05_b1bbf834-8ca1-40b8-b9cd-cd512add0ec0.webp' },
  { code: 'WS-06', name: 'Natural Oak',   swatch: 'https://cdn.shopify.com/s/files/1/0169/0386/4420/files/WS06_3f4c7e95-f864-478b-b89f-ad50cd5aebbe.webp' }
];
